
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_CONSIGNMENT_STATUS_LIST, GET_ASN_LIST, GET_STAKEHOLDER_CATEGORY, GET_ASN_CORRECTION_LIST, UPDATE_ASN } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { loaderService } from "../../../common/custom-loader/loader-service";
import moment from 'moment';
import { Container, Button, Box, TextField, Tooltip, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, CardContent, Grid, FormControl, InputLabel, Select, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { CloseIcon, EditIcon, SubmitIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

function AsnCorrection() {
    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const { state } = useLocation();
    const [asnDetails, setAsnDetails] = useState([]);
    const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
    const [openCorrection, setOpenCorrection] = useState(false);
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [selectedAsnData, setSelectedAsnData] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [updateResponse, setUpdateResponse] = useState();

    const [errorMessage, setErrorMessage] = useState({
        grossWeightError: "",
        tareWeightError: "",
    });

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    useEffect(() => {
        getAsnCorrectionDetails();
    }, [stakeholderDetails]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        getAsnCorrectionDetails(newValue);
    };

    const onViewDetails = (cellValues) => {
        setOpenCorrection(true);
        setErrorMessage({ grossWeightError: "", tareWeightError: "" });

        const incomingGross = cellValues?.destinationGrossWeight ? Number(cellValues.destinationGrossWeight * 1000) : 0;
        const incomingTare = cellValues?.destinationTareWeight ? Number(cellValues.destinationTareWeight * 1000) : 0;

        let initialNet = '';
        // Only calculate net if BOTH gross and tare are present and measurement is done
        if (incomingGross > 0 && incomingTare > 0 && cellValues?.isMeasurementDone !== false) {
            initialNet = (incomingGross - incomingTare).toFixed(4);
        } else if (cellValues?.destinationNetWeight && cellValues?.isMeasurementDone !== false) {
            initialNet = Number(cellValues.destinationNetWeight * 1000).toFixed(4);
        }

        setSelectedAsnData({
            ...selectedAsnData,
            asnNumber: cellValues?.asnNo,
            grnNo: cellValues?.grnNo,
            isSentBackForAsnCorrection: cellValues?.isSentBackForAsnCorrection,
            isRequestUpdated: cellValues?.isRequestUpdated || false,
            destinationGrossWeight: incomingGross ? incomingGross.toFixed(4) : '',
            destinationTareWeight: cellValues?.isMeasurementDone === false ? '' : (incomingTare ? incomingTare.toFixed(4) : ''),
            destinationNetWeight: initialNet,
            isMeasurementDone: cellValues?.isMeasurementDone
        });
    }

    const onCancel = () => {
        getAsnCorrectionDetails(tabValue);
        setOpenCorrection(false);
    }

    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    }

    const getAsnCorrectionDetails = (materialType) => {
        let data = {
            "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : '',
            "stakeholderType": stakeholderDetails?.category ? stakeholderDetails?.category : "",
            "roleType": localStorage.getItem('role') ? localStorage.getItem('role') : '',
            "materialType": materialType ? materialType : tabValue,
            "isSentBackForAsnCorrection": true,
        }

        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_ASN_CORRECTION_LIST, data, { headers })
            .then(res => setAsnDetails(res.data.asnList))
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
            });
        loaderService.hideLoader();
    };

    const columns = [
        { field: 'asnNo', headerName: 'ASN ID#', width: 120 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 130 },
        { field: 'challanNo', headerName: 'Delivery Challan Number', width: 180 },
        { field: 'grnNo', headerName: 'GRN Number', width: 150 },
        { field: 'sesNo', headerName: 'SES Number', width: 150 },
        {
            field: 'stakeholderSourceUrn', headerName: 'Source URN', width: 150,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn
        },
        {
            field: 'stakeholderSourceName', headerName: 'Source Name', width: 180,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName
        },
        { field: 'consignmentDestinationStakeholderUrn', headerName: 'Destination URN', width: 150 },
        {
            field: 'consignmentDestinationName', headerName: 'Destination Name', width: 200,
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                        {params.value}
                    </div>
                )
            },
            valueGetter: (params) => params.value
        },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 220 },
        { field: 'asnStatus', headerName: 'ASN Status', width: 220 },
        {
            field: 'asnDate', headerName: 'ASN Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        // {
        //     field: 'pickupNetWeight', headerName: 'ASN Quantity', width: 120,
        // },
        {
            field: 'Action', width: 150,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="Modify">
                        <IconButton
                            disabled={cellValues?.row?.grnNo && cellValues?.row?.isSentBackForAsnCorrection !== true}
                            color="primary"
                            onClick={() => onViewDetails(cellValues.row)}
                        >
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        let v = value;

        let [intPart, decPart] = v.split('.');
        intPart = intPart.slice(0, 10);
        if (decPart) decPart = decPart.slice(0, 4);
        v = decPart !== undefined ? `${intPart}.${decPart}` : intPart;

        const updated = { ...selectedAsnData, [name]: v };

        const gStr = updated.destinationGrossWeight;
        const tStr = updated.destinationTareWeight;

        // Only calculate if both strings exist and measurement is done
        if (gStr && tStr && updated.isMeasurementDone !== false) {
            const g = parseFloat(gStr);
            const t = parseFloat(tStr);
            updated.destinationNetWeight = (g - t).toFixed(4);
        } else {
            // Keep empty if either is missing
            updated.destinationNetWeight = '';
        }

        setSelectedAsnData(updated);

        if (name === "destinationGrossWeight") setErrorMessage(prev => ({ ...prev, grossWeightError: "" }));
        if (name === "destinationTareWeight") setErrorMessage(prev => ({ ...prev, tareWeightError: "" }));
    };

    const onSubmitButtonClick = (e) => {
        const gross = parseFloat(selectedAsnData?.destinationGrossWeight);
        const tare = parseFloat(selectedAsnData?.destinationTareWeight);
        const net = parseFloat(selectedAsnData?.destinationNetWeight);

        let hasError = false;
        let errors = { grossWeightError: "", tareWeightError: "" };

        // 1. Gross Weight Validation
        if (isNaN(gross) || gross <= 0) {
            errors.grossWeightError = "Gross weight must be greater than 0";
            hasError = true;
        }

        // 2 & 3. Tare and Net Weight Validation (Skip if measurement is not done)
        if (selectedAsnData?.isMeasurementDone !== false) {
            if (isNaN(tare) || tare <= 0) {
                errors.tareWeightError = "Tare weight must be greater than 0";
                hasError = true;
            }
            if (isNaN(net) || net <= 0) {
                toast.error("Net weight must be greater than 0");
                hasError = true;
            }
        }

        setErrorMessage(errors);

        if (hasError) return;

        handleConfirmOpen();
    }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await updateAsn();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const updateAsn = () => {
        const grossMT = (parseFloat(selectedAsnData.destinationGrossWeight || 0) / 1000).toFixed(4);

        const tareMT = selectedAsnData?.isMeasurementDone === false
            ? null
            : (parseFloat(selectedAsnData.destinationTareWeight || 0) / 1000).toFixed(4);

        // If measurement is not done or net weight is empty, send null
        const netMT = (selectedAsnData?.isMeasurementDone === false || !selectedAsnData?.destinationNetWeight)
            ? null
            : (parseFloat(selectedAsnData.destinationNetWeight) / 1000).toFixed(4);

        const payload = {
            asnNumber: selectedAsnData?.asnNumber,
            isSentBackForAsnCorrection: selectedAsnData?.isSentBackForAsnCorrection,
            destinationGrossWeight: grossMT,
            destinationTareWeight: tareMT,
            destinationNetWeight: netMT
        };

        loaderService.showLoader();
        apiClient
            .post(UPDATE_ASN, payload,
                {
                    headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') }
                }, null
            )
            .then((response) => {
                setUpdateResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (updateResponse) {
            if (updateResponse.isSuccess === true) {
                toast.success(updateResponse?.message);
                getAsnCorrectionDetails(tabValue);
                setOpenCorrection(false);
            }
            else {
                toast.error(updateResponse?.message ? updateResponse?.message : "Error");
            }
        }
    }, [updateResponse]);

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT06</p>}
                <Typography variant="h4" gutterBottom>
                    ASN Correction
                </Typography>
                <Card>
                    <CardContent>
                        {
                            !openCorrection ?
                                <TabContext value={tabValue}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleTabChange}>
                                            <Tab label="Raw Bamboo" value="RawBamboo" />
                                            <Tab label="Chip Bamboo" value="ChipBamboo" />
                                        </TabList>
                                    </Box>

                                    <TabPanel value="RawBamboo">
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="ChipBamboo">
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                </TabContext>
                                :
                                <>
                                    <Box display="flex" justifyContent="flex-start" mb={2}>
                                        <Button variant="outlined" onClick={() => onCancel()}>
                                            ← Back
                                        </Button>
                                    </Box>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={Boolean(errorMessage.grossWeightError)}
                                                helperText={errorMessage.grossWeightError}
                                                type="number"
                                                label='Gross weight (in KG) measured'
                                                name="destinationGrossWeight"
                                                onChange={(e) => handleChange(e)}
                                                value={selectedAsnData?.destinationGrossWeight || ''}
                                                inputProps={{ maxLength: 8 }}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                error={Boolean(errorMessage.tareWeightError)}
                                                helperText={errorMessage.tareWeightError}
                                                type="number"
                                                label='Tare weight (in KG) measured'
                                                name="destinationTareWeight"
                                                onChange={(e) => handleChange(e)}
                                                value={selectedAsnData?.isMeasurementDone === false ? '' : (selectedAsnData?.destinationTareWeight || '')}
                                                inputProps={{ maxLength: 8 }}
                                                disabled={selectedAsnData?.isMeasurementDone === false}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                value={(selectedAsnData?.destinationNetWeight) || ''}
                                                disabled
                                                type="number"
                                                label='Net weight(in KG) as per measurement'
                                                name="destinationNetWeight"
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                                <Button sx={{ minWidth: 100, ml: 1 }} variant="outlined" startIcon={<CloseIcon />} onClick={() => onCancel()}>Cancel</Button>

                                                <Button
                                                    sx={{ minWidth: 100, ml: 1 }}
                                                    variant="contained"
                                                    type='submit'
                                                    endIcon={<SubmitIcon />}
                                                    disabled={selectedAsnData?.isRequestUpdated === true}
                                                    onClick={() => onSubmitButtonClick()}
                                                >
                                                    Submit
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </>
                        }
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmClose} action="Update ASN" />
        </>
    );
}

export default AsnCorrection;
